/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetTaskQueryResult } from '../../models/get-task-query-result';

export interface ApiTaskGetTaskGet$Params {
  Id?: string;
}

export function apiTaskGetTaskGet(http: HttpClient, rootUrl: string, params?: ApiTaskGetTaskGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTaskQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskGetTaskGet.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetTaskQueryResult>;
    })
  );
}

apiTaskGetTaskGet.PATH = '/api/Task/GetTask';
